import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { UserConfig } from '@tunasong/manifest'
import manifest from '@tunasong/manifest'

// Define a type for the slice state
export interface AppConfig {
  baseDomain: string
  apiBaseUrl: string
  /** WebSocket endpoint. Its own origin on a local host (spec §8.1), API Gateway in the cloud */
  wsBaseUrl: string
  streamingApiBaseUrl: string

  userConfig: UserConfig
  // user config is loaded from persisted storage, e.g., profile
  userConfigLoaded: boolean
}

// Define the initial state using that type
const initialState: AppConfig = {
  baseDomain: 'tunasong.com',
  apiBaseUrl: 'https://tunasong.com/api',
  wsBaseUrl: 'wss://ws.api.tunasong.com',
  streamingApiBaseUrl: 'https://tunasong.com/stream',
  // Create a user config with the default values
  userConfig: manifest.userConfig.parse({ plugins: {} }),
  userConfigLoaded: false,
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setApiBaseUrl: (state, action: PayloadAction<{ apiBaseUrl: string }>) => {
      state.apiBaseUrl = action.payload.apiBaseUrl
    },
    setWsBaseUrl: (state, action: PayloadAction<{ wsBaseUrl: string }>) => {
      state.wsBaseUrl = action.payload.wsBaseUrl
    },
    setStreamingApiBaseUrl: (state, action: PayloadAction<{ streamingApiBaseUrl: string }>) => {
      state.streamingApiBaseUrl = action.payload.streamingApiBaseUrl
    },
    updateUserConfig: (state, action: PayloadAction<Partial<UserConfig>>) => {
      state.userConfig = { ...state.userConfig, ...action.payload }
    },
    setUserConfigLoaded: (state, action: PayloadAction<boolean>) => {
      state.userConfigLoaded = action.payload
    },
  },
})
